module.exports = __webpack_public_path__ + "static/media/key-solid.748fb992.svg";